<app-merchant-details
  [identity]="identity"
  [merchant]="merchant"
  [merchants]="recentMerchants"
></app-merchant-details>
<div
  *ngIf="identity && hasEntitlement('MERCHANTS_HISTORY_TRANSACTIONS')"
  id="trans_hist_search"
  class="card card-nc"
>
  <div class="card-heading">
    <span class="icon-NC_history"></span>
    <span class="transactionHistHeader">TRANSACTION HISTORY SEARCH</span>
    <span class="alignRight subCardHeaderHeading lastPwdLabelBox ">
      <div class="col-md-12 colAdj lastPassword lastPasswordCenter">
        Current as of
      </div>
      <div class="col-md-12 colAdj lastPassword ">
        {{ identity.currentShip.lastRoundtrip | date: 'fullDate' }}
      </div>
    </span>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-4 form-group">
        <label for="account" class="labelCommon">ACCOUNT</label>
        <span
          ><select
            class="form-control input-sm"
            name="acctSelected"
            id="acctSelected"
            [ngModel]="acctSelected"
            (change)="getSelectedTransHistory($event)"
          >
            <option value="">All</option>
            <option
              *ngFor="let acct of customerAccounts"
              [value]="acct.account"
              >{{ acct.account + ' - ' + acct.type }}</option
            >
          </select>
        </span>
      </div>
      <!-- /input-group -->
      <div class="form-group col-md-4">
        <label for="startDate" class="labelCommon">START DATE</label>
        <div class="input-group datepicker dtpicker-btn">
          <input
            id="tranMinDate"
            class="form-control"
            name="startDate"
            [maxDate]="endDate"
            [ngModel]="startDate"
            (ngModelChange)="startDate = $event"
            (dateSelect)="refreshMerchantTransactionData()"
            ngbDatepicker
            #d1="ngbDatepicker"
            readonly="readonly"
            (click)="d1.toggle()"
          />
          <div class="input-group-append">
            <button
              type="button"
              class="fa fa-calendar"
              (click)="d1.toggle()"
            ></button>
          </div>
        </div>
      </div>
      <div class="form-group col-md-4">
        <label for="endDate" class="labelCommon">END DATE</label>
        <div class="input-group datepicker dtpicker-btn">
          <input
            id="tranMaxDate"
            class="form-control"
            name="tranMaxDate"
            [minDate]="startDate"
            [ngModel]="endDate"
            (ngModelChange)="endDate = $event"
            (dateSelect)="refreshMerchantTransactionData()"
            ngbDatepicker
            #d2="ngbDatepicker"
            readonly="readonly"
            (click)="d2.toggle()"
          />
          <div class="input-group-append">
            <button
              type="button"
              class="fa fa-calendar"
              (click)="d2.toggle()"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<br /><br />
<div
  class="table-responsive"
  document-click="clearActionTips($event)"
  *ngIf="hasEntitlement('MERCHANTS_HISTORY_TRANSACTIONS')"
>
  <table class="table tableBackground tableRow table-bordered table-hover">
    <thead class="transactionHistHeader tableheading">
      <tr>
        <th class="text-center col-2">DATE</th>
        <th class="text-center col-2">POSTED</th>
        <th class="text-center col-1">TYPE</th>
        <th class="text-center col-3">DESCRIPTION</th>
        <th class="text-center col-2">AMOUNT</th>
        <th class="text-center col-2">BALANCE</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="dataLoading">
        <td colspan="7" style="text-align: center; height: 150px;">
          <i class="fa fa-spinner fa-2x fa-pulse"></i>
        </td>
      </tr>
      <tr *ngIf="filterTrans.length === 0 && !dataLoading">
        <td colspan="7" style="text-align: center; height: 150px;">
          No account activity found.
        </td>
      </tr>
      <ng-container *ngFor="let transaction of filterTrans">
        <ng-container>
          <tr>
            <td class="transactionHistText text-center col-2">
              {{ transaction.date | date: 'mediumDate' }}
            </td>
            <!-- pattern="MM/dd/yyyy" -->
            <td class="transactionHistText text-center col-2">
              {{ transaction.postDate | date: 'mediumDate' }}
            </td>
            <td
              class="transactionHistText text-center col-1"
              *ngIf="transaction.account !== stripAccount.account"
            >
              Chip
            </td>
            <td
              class="transactionHistText text-center col-1"
              *ngIf="transaction.account === stripAccount.account"
            >
              Strip
            </td>
            <td class="transactionHistText text-left col-4">
              {{ transaction.descr }}
              <span
                style="float: right;"
                *ngIf="transaction.reverseState == -1"
                [ngClass]="{
                  greenBackGround: transaction.amount >= 0.0,
                  redBackGround: transaction.amount < 0.0
                }"
                >R</span
              >
            </td>
            <td
              class="text-center col-2"
              [ngClass]="{
                'text-success': transaction.amount >= 0.0,
                'text-fail': transaction.amount < 0.0
              }"
            >
              {{ transaction.amount | currency }}
            </td>
            <td
              class="text-center col-2"
              [ngClass]="{
                'text-success': transaction.balance >= 0.0,
                'text-fail': transaction.balance < 0.0
              }"
            >
              {{ transaction.balance | currency }}
            </td>

            <td>
              <a
                ><i
                  *ngIf="!transaction.expanded"
                  class="fa fa-plus-square"
                  (click)="
                    transaction.expanded = true; showDetails(transaction)
                  "
                ></i>
                <i
                  *ngIf="transaction.expanded"
                  class="fa fa-minus-square"
                  (click)="transaction.expanded = false"
                ></i>
              </a>
            </td>
          </tr>
          <tr *ngIf="transaction.expanded">
            <td colspan="7">
              <div *ngIf="transaction.c2cDetails !== ''">
                {{ transaction.c2cDetails }}
              </div>
              <div *ngFor="let trans of transaction.tranDetails | keyvalue">
                <span class="transactionHistText"
                  ><strong>{{ trans.key }}</strong
                  >&nbsp;{{ trans.value }}</span
                >
              </div>
              <div
                *ngIf="
                  transaction.reverseState !== -1 &&
                  transaction.reverseState !== 0 &&
                  hasEntitlement('MERCHANTS_HISTORY_TRANSACTION_REVERSE')
                "
                class="text-center float-right"
                style="width: 175px;"
              >
                <app-confirm-button-combo
                  [addSyncFixed]="false"
                  [baseLabel]="' Reverse '"
                  (confirmSelected)="reverse(transaction)"
                  [commit_btn_spinner]="applyReverseButtonSpinnerString"
                >
                </app-confirm-button-combo>
              </div>
            </td>
            <td
              colspan="2"
              *ngIf="transaction.reverseState === -1"
              class="reverseSection"
            >
              Has Been Reversed
            </td>
            <td
              colspan="2"
              *ngIf="
                transaction.reverseState !== -1 &&
                !hasEntitlement('MERCHANTS_HISTORY_TRANSACTION_REVERSE')
              "
            ></td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
</div>
